export function registerReveal() {
  const targets = document.querySelectorAll(".reveal")
  if (!targets.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          observer.unobserve(entry.target)
        }
      }
    },
    { threshold: 0.2 }
  )

  targets.forEach((target) => observer.observe(target))
}
